export default {"src":"/_next/static/media/profile-pro.e9288cf6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};